import { FileText, Handshake, FolderKanban } from "lucide-react";
import type { NotificationType } from "@/types/inbox.types";

export const getTypeIcon = (type: NotificationType) => {
  switch (type) {
    case "document":
      return FileText;
    case "contract":
      return Handshake;
    case "deal":
      return FolderKanban;
  }
};

export const getTypeColor = (type: NotificationType) => {
  switch (type) {
    case "document":
      return "bg-[#00bbff2b] dark:bg-[#00bbff2b] text-[#00bbff] dark:text-[#00bbff]";
    case "contract":
      return "bg-[#80dc002b] dark:bg-[#95ff002b] text-[#63aa00] dark:text-[#95ff00]";
    case "deal":
      return "bg-[#e3cd3a31] text-[#9e8c00] dark:text-[#ffe20a]";
  }
};

export type ActorAvatarLookup = Record<string, string | undefined>;

export const getActorAvatar = (actor: string | undefined, lookup: ActorAvatarLookup): string | undefined => {
  if (!actor) return undefined;
  return lookup[actor];
};

export const getActorInitials = (actor?: string): string => {
  if (!actor) return "?";
  if (actor === "You" || actor === "Demo User") return "DU";
  if (actor === "Legal Team") return "LT";
  if (actor === "System") return "SY";
  return actor
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
};
